import { RegionState } from '../types';

export const countryData: Record<string, RegionState[]> = {
  europe: [
    { id: 'AL', name: 'Albania' },
    { id: 'AD', name: 'Andorra' },
    { id: 'AT', name: 'Austria' },
    { id: 'BY', name: 'Belarus' },
    { id: 'BE', name: 'Belgium' },
    { id: 'BA', name: 'Bosnia and Herzegovina' },
    { id: 'BG', name: 'Bulgaria' },
    { id: 'HR', name: 'Croatia' },
    { id: 'CZ', name: 'Czech Republic' },
    { id: 'DK', name: 'Denmark' },
    { id: 'EE', name: 'Estonia' },
    { id: 'FI', name: 'Finland' },
    { id: 'FR', name: 'France' },
    { id: 'DE', name: 'Germany' },
    { id: 'GR', name: 'Greece' },
    { id: 'HU', name: 'Hungary' },
    { id: 'IS', name: 'Iceland' },
    { id: 'IE', name: 'Ireland' },
    { id: 'IT', name: 'Italy' },
    { id: 'LV', name: 'Latvia' },
    { id: 'LI', name: 'Liechtenstein' },
    { id: 'LT', name: 'Lithuania' },
    { id: 'LU', name: 'Luxembourg' },
    { id: 'MT', name: 'Malta' },
    { id: 'MD', name: 'Moldova' },
    { id: 'MC', name: 'Monaco' },
    { id: 'ME', name: 'Montenegro' },
    { id: 'NL', name: 'Netherlands' },
    { id: 'MK', name: 'North Macedonia' },
    { id: 'NO', name: 'Norway' },
    { id: 'PL', name: 'Poland' },
    { id: 'PT', name: 'Portugal' },
    { id: 'RO', name: 'Romania' },
    { id: 'RU', name: 'Russia' },
    { id: 'SM', name: 'San Marino' },
    { id: 'RS', name: 'Serbia' },
    { id: 'SK', name: 'Slovakia' },
    { id: 'SI', name: 'Slovenia' },
    { id: 'ES', name: 'Spain' },
    { id: 'SE', name: 'Sweden' },
    { id: 'CH', name: 'Switzerland' },
    { id: 'UA', name: 'Ukraine' },
    { id: 'GB', name: 'United Kingdom' },
    { id: 'VA', name: 'Vatican City' }
  ],
  americas: [
    { id: 'AR', name: 'Argentina' },
    { id: 'BS', name: 'Bahamas' },
    { id: 'BB', name: 'Barbados' },
    { id: 'BZ', name: 'Belize' },
    { id: 'BO', name: 'Bolivia' },
    { id: 'BR', name: 'Brazil' },
    { id: 'CA', name: 'Canada' },
    { id: 'CL', name: 'Chile' },
    { id: 'CO', name: 'Colombia' },
    { id: 'CR', name: 'Costa Rica' },
    { id: 'CU', name: 'Cuba' },
    { id: 'DM', name: 'Dominica' },
    { id: 'DO', name: 'Dominican Republic' },
    { id: 'EC', name: 'Ecuador' },
    { id: 'SV', name: 'El Salvador' },
    { id: 'GD', name: 'Grenada' },
    { id: 'GT', name: 'Guatemala' },
    { id: 'GY', name: 'Guyana' },
    { id: 'HT', name: 'Haiti' },
    { id: 'HN', name: 'Honduras' },
    { id: 'JM', name: 'Jamaica' },
    { id: 'MX', name: 'Mexico' },
    { id: 'NI', name: 'Nicaragua' },
    { id: 'PA', name: 'Panama' },
    { id: 'PY', name: 'Paraguay' },
    { id: 'PE', name: 'Peru' },
    { id: 'LC', name: 'Saint Lucia' },
    { id: 'SR', name: 'Suriname' },
    { id: 'TT', name: 'Trinidad and Tobago' },
    { id: 'US', name: 'United States' },
    { id: 'UY', name: 'Uruguay' },
    { id: 'VE', name: 'Venezuela' }
  ],
  africa: [
    { id: 'DZ', name: 'Algeria' },
    { id: 'AO', name: 'Angola' },
    { id: 'BJ', name: 'Benin' },
    { id: 'BW', name: 'Botswana' },
    { id: 'BF', name: 'Burkina Faso' },
    { id: 'BI', name: 'Burundi' },
    { id: 'CM', name: 'Cameroon' },
    { id: 'CV', name: 'Cape Verde' },
    { id: 'CF', name: 'Central African Republic' },
    { id: 'TD', name: 'Chad' },
    { id: 'KM', name: 'Comoros' },
    { id: 'CD', name: 'Congo (DRC)' },
    { id: 'CG', name: 'Congo Republic' },
    { id: 'CI', name: 'Côte d\'Ivoire' },
    { id: 'DJ', name: 'Djibouti' },
    { id: 'EG', name: 'Egypt' },
    { id: 'GQ', name: 'Equatorial Guinea' },
    { id: 'ER', name: 'Eritrea' },
    { id: 'ET', name: 'Ethiopia' },
    { id: 'GA', name: 'Gabon' },
    { id: 'GM', name: 'Gambia' },
    { id: 'GH', name: 'Ghana' },
    { id: 'GN', name: 'Guinea' },
    { id: 'GW', name: 'Guinea-Bissau' },
    { id: 'KE', name: 'Kenya' },
    { id: 'LS', name: 'Lesotho' },
    { id: 'LR', name: 'Liberia' },
    { id: 'LY', name: 'Libya' },
    { id: 'MG', name: 'Madagascar' },
    { id: 'MW', name: 'Malawi' },
    { id: 'ML', name: 'Mali' },
    { id: 'MR', name: 'Mauritania' },
    { id: 'MU', name: 'Mauritius' },
    { id: 'MA', name: 'Morocco' },
    { id: 'MZ', name: 'Mozambique' },
    { id: 'NA', name: 'Namibia' },
    { id: 'NE', name: 'Niger' },
    { id: 'NG', name: 'Nigeria' },
    { id: 'RW', name: 'Rwanda' },
    { id: 'ST', name: 'São Tomé and Príncipe' },
    { id: 'SN', name: 'Senegal' },
    { id: 'SC', name: 'Seychelles' },
    { id: 'SL', name: 'Sierra Leone' },
    { id: 'SO', name: 'Somalia' },
    { id: 'ZA', name: 'South Africa' },
    { id: 'SS', name: 'South Sudan' },
    { id: 'SD', name: 'Sudan' },
    { id: 'SZ', name: 'Eswatini' },
    { id: 'TZ', name: 'Tanzania' },
    { id: 'TG', name: 'Togo' },
    { id: 'TN', name: 'Tunisia' },
    { id: 'UG', name: 'Uganda' },
    { id: 'ZM', name: 'Zambia' },
    { id: 'ZW', name: 'Zimbabwe' }
  ],
  asia: [
    { id: 'AF', name: 'Afghanistan' },
    { id: 'AM', name: 'Armenia' },
    { id: 'AZ', name: 'Azerbaijan' },
    { id: 'BH', name: 'Bahrain' },
    { id: 'BD', name: 'Bangladesh' },
    { id: 'BT', name: 'Bhutan' },
    { id: 'BN', name: 'Brunei' },
    { id: 'KH', name: 'Cambodia' },
    { id: 'CN', name: 'China' },
    { id: 'CY', name: 'Cyprus' },
    { id: 'GE', name: 'Georgia' },
    { id: 'HK', name: 'Hong Kong' },
    { id: 'IN', name: 'India' },
    { id: 'ID', name: 'Indonesia' },
    { id: 'IR', name: 'Iran' },
    { id: 'IQ', name: 'Iraq' },
    { id: 'IL', name: 'Israel' },
    { id: 'JP', name: 'Japan' },
    { id: 'JO', name: 'Jordan' },
    { id: 'KZ', name: 'Kazakhstan' },
    { id: 'KW', name: 'Kuwait' },
    { id: 'KG', name: 'Kyrgyzstan' },
    { id: 'LA', name: 'Laos' },
    { id: 'LB', name: 'Lebanon' },
    { id: 'MO', name: 'Macau' },
    { id: 'MY', name: 'Malaysia' },
    { id: 'MV', name: 'Maldives' },
    { id: 'MN', name: 'Mongolia' },
    { id: 'MM', name: 'Myanmar' },
    { id: 'NP', name: 'Nepal' },
    { id: 'KP', name: 'North Korea' },
    { id: 'OM', name: 'Oman' },
    { id: 'PK', name: 'Pakistan' },
    { id: 'PS', name: 'Palestine' },
    { id: 'PH', name: 'Philippines' },
    { id: 'QA', name: 'Qatar' },
    { id: 'SA', name: 'Saudi Arabia' },
    { id: 'SG', name: 'Singapore' },
    { id: 'KR', name: 'South Korea' },
    { id: 'LK', name: 'Sri Lanka' },
    { id: 'SY', name: 'Syria' },
    { id: 'TW', name: 'Taiwan' },
    { id: 'TJ', name: 'Tajikistan' },
    { id: 'TH', name: 'Thailand' },
    { id: 'TL', name: 'Timor-Leste' },
    { id: 'TR', name: 'Turkey' },
    { id: 'TM', name: 'Turkmenistan' },
    { id: 'AE', name: 'United Arab Emirates' },
    { id: 'UZ', name: 'Uzbekistan' },
    { id: 'VN', name: 'Vietnam' },
    { id: 'YE', name: 'Yemen' }
  ],
  oceania: [
    { id: 'AU', name: 'Australia' },
    { id: 'FJ', name: 'Fiji' },
    { id: 'KI', name: 'Kiribati' },
    { id: 'MH', name: 'Marshall Islands' },
    { id: 'FM', name: 'Micronesia' },
    { id: 'NR', name: 'Nauru' },
    { id: 'NZ', name: 'New Zealand' },
    { id: 'PW', name: 'Palau' },
    { id: 'PG', name: 'Papua New Guinea' },
    { id: 'WS', name: 'Samoa' },
    { id: 'SB', name: 'Solomon Islands' },
    { id: 'TO', name: 'Tonga' },
    { id: 'TV', name: 'Tuvalu' },
    { id: 'VU', name: 'Vanuatu' }
  ]
};